module.exports = __webpack_public_path__ + "static/toys-1-2206a6220e58301d187f0a0b40cb0851.jpg";